import React from "react";
import { Draggable } from "components/drag-and-drop";
import { Brikk } from "components/Brikk";
import { SeeMoreButton } from "components/form-elements/buttons/SeeMoreButton";
import { Image } from "components/media/Image";
import { DocumentsIcon } from "assets/icons/brikks/DocumentsIcon";
import brikkPreviewSrc from "components/brikks/Office/Documents/assets/documents-brikk-preview.png";

export const Documents = ({ position }) => {
  return (
    <>
      <Draggable position={position}>
        <Brikk disabled={true}>
          <Brikk.Header icon={<DocumentsIcon />} heading="documentsBrikk" />

          <Brikk.Content center>
            <Image src={brikkPreviewSrc} />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton disabled={true} brikkNameIntl="documents" />
          </Brikk.Button>
        </Brikk>
      </Draggable>
    </>
  );
};
